import React, {Component} from 'react';
import {BASE_PATH, STATUS_NAME} from "../../../../wpconfig";
import {NavLink} from "react-router-dom";
import {Line} from "react-chartjs-2";
import {getDateYMD} from "../../../../utils/functions"
class JournalItem extends Component {
	constructor(props) {
		super(props);

		this.state = {
			url : "admin.php?" + window.location.href.split("?")[1]
		}
	}

	componentDidUpdate() {
		setTimeout(() => {
			this.setState({
					'url' : "admin.php?" + window.location.href.split("?")[1]
			})
		}, 0);
	}

	render() {
		const record = this.props.record;

		let rdb = {
			'scie' : { 'name' : 'SE' , 'class' : 'btn db-check'},
			'ssci' : { 'name' : 'SS' , 'class' : 'btn db-check'},
			'ahci' : { 'name' : 'AH' , 'class' : 'btn db-check'},
			'esci' : { 'name' : 'ES' , 'class' : 'btn db-check'},
			'scopus' : { 'name' : 'SP' , 'class' : 'btn db-check'},
			'nature' : { 'name' : 'NA' , 'class' : 'btn db-check'},
			'kci' : { 'name' : 'KC' , 'class' : 'btn db-check'},
			'kci_great' : { 'name' : 'KG' , 'class' : 'btn db-check'},
			'kci_can' : { 'name' : 'KD' , 'class' : 'btn db-check'}
		}

		record.registered_db && record.registered_db.map((db, index) => {
			if(db.name === 'SCIE') rdb.scie.class += ' checked';
			else if(db.name === 'SSCI') rdb.ssci.class += ' checked';
			else if(db.name === 'AHCI') rdb.ahci.class += ' checked';
			else if(db.name === 'ESCI') rdb.esci.class += ' checked';
			else if(db.name === 'Scopus') rdb.scopus.class += ' checked';
			else if(db.name === 'Nature Index') rdb.nature.class += ' checked';
			else if(db.name === 'KCI') rdb.kci.class += ' checked';
			else if(db.name === 'KCI우수') rdb.kci_great.class += ' checked';
			else if(db.name === 'KCI후보') rdb.kci_can.class += ' checked';
		})

		return (
			<tr>
				<td scope="row" className="mr-0">
					<input type="checkbox" className="ml-0" value={record.journal_id}
					       checked={this.props.checked}
					       onChange={this.props.onRecordCheck}/>
				</td>
				<td>{this.props.no}</td>
				<td>{record.journal_id}</td>
				<td>
					<p className="mb-0">
						<a href={this.state.url + "&record_id=" + this.props.record.journal_id}><strong>{record.journal_title}</strong></a>
					</p>
					<p className="mb-0">{record.publisher}</p>
				</td>
				<td>{record.issn}</td>
				<td>{record.country}</td>
				<td className="pl-0 pr-0 ml-0 mr-0">
					{Object.keys(rdb).map((db, index) => {
						return(<span key={index} className={rdb[db].class}>{rdb[db].name}</span>)
					})}
				</td>
				<td>{!record.journal_status ? <span className="badge badge-item-status bg-danger">확인필요</span>
					: record.journal_status === 'publish' ? <span className="badge badge-item-status badge-success">{STATUS_NAME[record.journal_status]}</span>
					: record.journal_status === 'draft' ? <span className="badge badge-item-status badge-warning">{STATUS_NAME[record.journal_status]}</span>
					: record.journal_status === 'trash' ? <span className="badge badge-item-status badge-dark">{STATUS_NAME[record.journal_status]}</span>
					: record.journal_status === 'unpublish' ? <span className="badge badge-item-status badge-secondary">{STATUS_NAME[record.journal_status]}</span>
					: ''
				}
				</td>
				<td>{getDateYMD(record.input_date)}</td>
				<td>{getDateYMD(record.modified_date)}</td>
			</tr>
		)
	}
}

export default JournalItem;

// Journals.propTypes = {
//     monitor_box_status: PropTypes.bool,
//     listStatus: PropTypes.array,
//     id: PropTypes.string,
//     companyStatus: PropTypes.string,
//     companyName: PropTypes.string,
//     address: PropTypes.string,
//     reportID: PropTypes.string,
//     isUserList: PropTypes.string,
//     createDate: PropTypes.string,
//     startDate: PropTypes.string,
//     endDate: PropTypes.string,
//     advertiserName: PropTypes.string,
//     advertiserPhone: PropTypes.string,
//     operatorPhone: PropTypes.string,
//     operatorName: PropTypes.string,
//     reportKeywords: PropTypes.array,
//     monitoringInfo: PropTypes.string,
// };
